import {useState, useEffect, useRef} from 'react';
import {useInterval, strArraySortAsc, showToast} from '../common/app_common.js';
import {Title, PageNation} from '../common/component_common.js';
import '../common/css/capacity.css';
import {getApiSitesKeyword} from '../common/fetch_api/site.js';
import {getApiSpectrumCount, getApiSpectrum} from '../common/fetch_api/capacity.js';
import { BsChevronExpand, BsSearch } from 'react-icons/bs';

const PageCapacity = () =>
{
    const [siteName, setSiteName] = useState('');
    const [market, setMarket] = useState('');
    const [category, setCategory] = useState('');
    const [rangeValue, setRangeValue] = useState({minValue: '', maxValue: ''});

    const queryRange = (min, max, selectedCategory) =>
    {
        if(min !== '' && max !== '')
        {
            setCategory(selectedCategory);
            setRangeValue({'minValue': min, 'maxValue': max});
        }
        else
        {
            setCategory('');
            setRangeValue({'minValue': '', 'maxValue': ''});
        }
    }

    return (
        <>
            <Title title='Capacity'></Title>
            <div className="d-flex flex-column mt-2">
                <SpectrumFilter
                    siteName={siteName}
                    setSiteName={setSiteName}
                    market={market}
                    setMarket={setMarket}
                    queryRange={queryRange}
                />
                <SpectrumTable  siteName={siteName} market={market} category={category} rangeValue={rangeValue} />
            </div>
        </>
    )
}

export default PageCapacity;

const SpectrumFilter = ({siteName, setSiteName, market, setMarket, queryRange}) =>
{
    const [sitesList, setSitesList] = useState([]);
    const [marketList, setMarketList] = useState([]);

    const [showRange, setShowRange] = useState(false);

    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(0);

    const [selectCategory, setSelectCategory] = useState('');

    const [update, setUpdate] = useState(false);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const onChangeSite = (e) =>
    {
        setSiteName(e.target.value);
        setMarket('');
    }

    const onChangeMarket = (e) =>
    {
        setMarket(e.target.value);
    }

    const onChangeCategory = (e) =>
    {
        if(e.target.value !== '')
        {
            setShowRange(true);
            setTimeout(() =>{
                minInputFocus.current.select();
            }, 100)
        }
        else
        {
            setShowRange(false);
            setMinValue(0);
            setMaxValue(0);
            queryRange('', '', '');
        }

        setSelectCategory(e.target.value);
    }

    const minInputFocus = useRef(null);
    const maxInputFocus = useRef(null);

    const onChangeMin = (e) =>
    {
        const input = parseFloat(e.target.value.trim()) * 1000000;

        if (isNaN(input) || input < 0 || input > 50000000)
        {
            setMinValue(minValue);
            setTimeout(() => {
                minInputFocus.current.select();
            }, 100);
        }
        else
        {
            setMinValue(input);
        }
    }

    const onChangeMax = (e) =>
    {
        let input = parseFloat(e.target.value.trim()) * 1000000;

        if (input === '' || isNaN(input))
        {
            setMaxValue('');
            setTimeout(() => {
                if (maxInputFocus.current)
                {
                    maxInputFocus.current.select();
                }
            }, 100);
        }
        else
        {
            if (input <= minValue || input > 50000000)
            {
                showToast('Please enter a value greater than the Min or less than 50Mbps.!', 'warning');
            }
            else
            {
                setMaxValue(input);
            }
        }
    }

    const handleOnKeyPress = (e) =>
    {
        if (e.key === 'Enter')
        {
            if (minValue >= maxValue)
            {
                showToast('Please enter Min value less than the Max value!', 'warning');
                setMinValue(0);
                setTimeout(() => {
                    minInputFocus.current.select();
                }, 100);

                return;
            }
            
            queryRange(minValue, maxValue, selectCategory);
        }
    };

    const onclickSearch = () =>
    {
        if (minValue >= maxValue)
        {
            showToast('Please enter Min value less than the Max value!', 'warning');
            setMinValue(0);
            setTimeout(() => {
                minInputFocus.current.select();
            }, 100);
        }
        else
        {
            queryRange(minValue, maxValue, selectCategory);
        }
    }

    useEffect(() =>
    {
        Promise.resolve( getApiSitesKeyword() )
        .then( data =>
        {
            if(data.callsign.length > 0)
            {
                let callsignArr = [...data.callsign];
                let marketArr = [...data.market];

                callsignArr.sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));
                marketArr.sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));

                setSitesList(callsignArr);
                setMarketList(marketArr);
            }
        })
    },[update])

    useInterval(() =>
    {
        runUpdate();
    }, 10000);
    
    return (
        <div className="section filter-area">
            <div className="section-title mb-1">Filter</div>
            <div className='d-flex flex-wrap'>
                <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 d-flex">
                    <div className="col-4 label-box">Site</div>
                    <div className="col-7 ps-1">
                        <select className="form-select form-select-sm" value={siteName} onChange={onChangeSite}>
                            <option value=''>Select Site</option>
                            {sitesList.length && sitesList.map((item, i)=>(
                                <option key={i} value={item}>{item}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 d-flex">
                    <div className="col-4 label-box">Market</div>
                    <div className="col-7 ps-1">
                        <select className="form-select form-select-sm" value={market} onChange={onChangeMarket}>
                            <option value=''>Select Market</option>
                            {marketList.length && marketList.map((item, i)=>(
                                <option key={i} value={item}>{item}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 d-flex">
                    <div className="col-4 label-box">Category</div>
                    <div className="col-7 ps-1">
                        <select className="form-select form-select-sm" value={selectCategory} onChange={onChangeCategory} >
                            <option value=''>Select Category</option>
                            <option value='total_remain_bitrate'>Total remain bitrate</option>
                            <option value='remain_bitrate'>Remain bitrate</option>
                        </select>
                    </div>
                </div>
                {showRange && <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 d-flex">
                    <div className="col-4 label-box">Range (Mbps)</div>
                    <div className="col-7 ps-1 d-flex range-input">
                        <input className="form-control input-box me-1" type="text"
                            ref={minInputFocus}
                            value={parseFloat(minValue/1000000)}
                            onChange={onChangeMin}
                            onKeyDown={handleOnKeyPress}
                        />
                        <span className='mx-2 mt-1'>~</span>
                        <input className="form-control input-box me-1" type='text'
                            ref={maxInputFocus}
                            value={parseFloat(maxValue / 1000000)}
                            onChange={onChangeMax}
                            onKeyDown={handleOnKeyPress}
                        />
                        <button type="button" className="btn btn-primary btn-sm search-range" onClick={onclickSearch} ><BsSearch /></button>
                    </div>
                </div>}
            </div>
        </div>
    )
}

const SpectrumTable = ({siteName, market, category, rangeValue}) =>
{
    const [tableSpinner, setTableSpinner] = useState(false);

    const [pageSelCount, setPageSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);
    const PAGE_PER = 19;

    const [thead, setThead] = useState(null);
    const [tbody, setTbody] = useState(null);

    const [sorting, setSorting] = useState({sortType: 'site_name', sortOrder: 'asc'});

    const onClickSort = (sortType) =>
    {
        setSorting({...sorting, sortType: sortType, sortOrder: sorting.sortOrder === 'asc' ? 'desc' : 'asc'});
    }

    const getSpectrum = () =>
    {
        curPageRef.current.value = curPageState;
        
        Promise.resolve( getApiSpectrumCount(siteName, market) )
        .then( data =>
        {
            if(data.hasOwnProperty('count'))
            {
                setPageSelCount(Math.max(data.count, 1));

                // console.log(curPageState, siteName, market, category, rangeValue.minValue, rangeValue.maxValue, sorting.sortType, sorting.sortOrder)

                Promise.resolve( getApiSpectrum(PAGE_PER, curPageState, siteName, market, category, rangeValue.minValue, rangeValue.maxValue, sorting.sortType, sorting.sortOrder) )        
                .then( data =>
                {
                    // console.log('table data', data)
                    if(data.length > 0)
                    {
                        setThead(makeThead(data));
                        setTbody(makeTbody(data));
                    }
                    else
                    {
                        setTbody([]);
                    }
                    setTimeout(() => {setTableSpinner(false);}, 700);
                }).catch(e => {
                    setTimeout(() => {setTableSpinner(false);}, 700);
                });
            }
            else
            {
                setTbody([]);
            }
            setTimeout(() => {setTableSpinner(false);}, 700);
        }).catch(e => {
            setTimeout(() => {setTableSpinner(false);}, 700);
        });
    }

    const makeTbody = (data) =>
    {
        let html = [];
       
        data.forEach((item, index) =>
        {
            html.push(
                <tr key={index}>
                    <td>{item.site}</td>
                    <td>{item.market}</td>
                    <td>
                        <div className="d-flex">
                            <span className='plp-value'>{(item.spectrum.total.availableBitrate/1000000).toFixed(2)}</span>
                            <span className='mx-2'>/</span>
                            <span className='plp-value text-good'>{(item.spectrum.total.remainBitrate/1000000).toFixed(2)}</span>
                        </div>
                    </td>
                    <PlpHtml plpData={item.spectrum} />
                </tr>
            );
        });
        
        return html;
    }

    const makeThead = (data) =>
    {
        let max = 0;
        //spectrum 객체의 가장 긴것 찾기 (total은 빼고)
        for(const item of data)
        {
            max = Math.max(max, Object.keys(item.spectrum).length - 1);
        }

        let html = [];
        for(let i = 0; i < max; i++)
        {
            html.push(
                <th key={i} className="sorting" onClick={() => {onClickSort(`plp${i}`)}}>
                    <span className='no-click'>PLP{i} </span>
                    <span className='no-click'>Available</span>
                    <span className='no-click mx-1'>/</span>
                    <span className='no-click text-good'>Remaining (Mbps)</span><BsChevronExpand />
                </th>
            );
        }
        
        return html;
    }

    function callGetSpectrum(initPage)
    {
        setTableSpinner(true);
        getSpectrum();
        if( initPage )
        {
            setCurPageState(1);
        }
    }

    const firstLoading = useRef(true);

    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            callGetSpectrum(true);
        }
    }, [siteName, market, category, rangeValue, sorting]);

    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            callGetSpectrum(false);
        }
    }, [curPageState]);

    useEffect(() =>
    {
        callGetSpectrum(true);
        firstLoading.current = false;
    }, []);

    useInterval(() =>
    {
        callGetSpectrum(false);
    }, 10000 );

    return (
        <>
        <div className="d-flex flex-column">
            <div className="section spectrum-table position-relative">
                {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
                <table className="table">
                    <thead>
                        <tr>
                            <th className="sorting" onClick={() => {onClickSort('site_name')}}>Callsign<BsChevronExpand/></th>
                            <th className="sorting" onClick={() => {onClickSort('market')}}>Market<BsChevronExpand/></th>
                            <th className="sorting" onClick={() => {onClickSort('total')}}>
                                <span className='no-click'>Total </span>
                                <span className='no-click'>Available</span>
                                <span className='no-click mx-1'>/</span>
                                <span className='no-click text-good'>Remaining (Mbps)</span><BsChevronExpand />
                            </th>
                            {thead}
                        </tr>
                    </thead>
                    <tbody>
                        {tbody}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setCurPageState}
                selCount={pageSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
        </div>
        </>
    )
}

const PlpHtml = ({plpData}) =>
{
    const [html, setHtml] = useState(null);

    //total 객체를 삭제함.
    const {total, ...plpInfo} = plpData;

    function getMaxColor(val)
    {
        let Max = 0;
        for( const key of Object.keys(plpInfo) )
        {
            Max = Math.max(Max, plpInfo[key].remainBitrate);
        }

        if( val === Max)        
        {
            return 'max-plp';
        }

        return 'reg-plp';
    }

    useEffect( () =>
    {
        setHtml(
            Object.keys(plpInfo).map((item, idx) => (
                <td key={idx}>
                    <div className="d-flex">
                        <span className='plp-value'>{(plpData[item].availableBitrate/1000000).toFixed(2)}</span>
                        <span className='mx-2'>/</span>
                        <span className={`plp-value text-good ${getMaxColor(plpData[item].remainBitrate)}`}>{(plpData[item].remainBitrate/1000000).toFixed(2)}</span>
                    </div>
                </td>
            ))
        )
    }, [plpData]);

    return (
        <>
            {html}        
        </>
    )
}